import { createAction } from '@reduxjs/toolkit';

import type { CartProductForUpdate, CartProduct } from './cart_products.types';

const getAll = {
  pending: createAction('cartProducts/getAllCartProducts/pending'),
  fulfilled: createAction<CartProduct[]>('cartProducts/getAllCartProducts/fulfilled'),
  rejected: createAction('cartProducts/getAllCartProducts/rejected'),
};

const checkThumbs = createAction<CartProduct[]>('cartProducts/checkThumbs');

const update = {
  fulfilled: createAction<CartProduct>('cartProducts/update/fulfilled'),
  rejected: createAction('cartProducts/update/rejected'),
};

const updateQuantity = {
  pending: createAction<Required<Pick<CartProductForUpdate, 'id' | 'quantity'>>>(
    'cartProducts/updateQuantity/pending'
  ),
  fulfilled: createAction<CartProduct>('cartProducts/updateQuantity/fulfilled'),
  rejected: createAction('cartProducts/updateQuantity/rejected'),
};

const destroy = {
  pending: createAction<number>('cartProducts/destroy/pending'),
  fulfilled: createAction<number>('cartProducts/destroy/fulfilled'),
  rejected: createAction('cartProducts/destroy/rejected'),
};

export default {
  getAll,
  checkThumbs,
  update,
  updateQuantity,
  destroy,
};
